import React, { Component } from 'react';
import axios from 'axios';
import InputField from '../../components/fields.component';
import categories from './categories.statics';
import { Modal, Form } from 'react-bootstrap';
import Spinner from '../../components/spinner.component';
import {MSG,allowedSize, allowedMimeTypes} from  '../../constants';

class InactiveEmapta extends Component {
	state = {
		formErrors: [],
		formData: {
			workspace_id: 4,
			full_name_of_the_requestor_first_name_last_name: { value: "", id: null, field_type: "", show: true },
			subject: { value: "", id: null, field_type: "", show: true },
			position_of_the_requestor: { value: "", id: null, field_type: "", show: true },
			establishment_or_company_represented_by_requestor: { value: "", id: null, field_type: "", show: true },
			full_name_of_the_emapta_employee_that_is_being_verifiedchecked_first_name_middle_name_last_name: { value: "", id: null, field_type: "", show: true },
			requester: { value: "", id: null, field_type: "", show: true },
			type_the_employee_id_number_of_the_emapta_staff_if_available: { value: "", id: null, field_type: "", show: true },
			type_of_inquiry_nonemapta_member: { value: "", id: null, field_type: "", show: true },
			file: null,
			description: { value: "n/a", id: null, field_type: "", show: false },
		},
		isAttachmentRequired: true,
		attachmentMessages: [
			"Valid company ID of requestor (Representative from Third Party)",
			"Consent approval proof (Certification of Consent from Emapta Employee)",
			"Valid ID of employee (Document submitted by Emapta Employee to Third Party)"],
		formFields: [],
		formStatus: {
			submitted: false
		},
		submitModal: {
			show: false
		},
		formErrorModal: {
			show: false,
			message: []
		},
		requiredFieldModal: {
			show: false,
		},
		page: {
			loaded: false
		}
	}


	componentDidMount = async () => {
		let { page, formData, formFields } = this.state;

		let fieldRequest = await this.getFields();

		if (fieldRequest.status) {

			fieldRequest.data.map(field => {
				formFields.push({
					name: field.name,
					label_for_customers: field.label_for_customers,
					belongs_to_section: field.belongs_to_section,
					choices: field.choices,
					default_field: field.default_field,
					description: field.description,
					displayed_to_customers: field.displayed_to_customers,
					field_type: field.field_type,
					field_id: field.field_id,
					id: field.id,
					nested_fields: field.nested_fields,
					position: field.position,
					required_for_customers: field.required_for_customers,
					sections: field.sections,
				})
			});

			formFields.push({
				file: null
			});

			Object.keys(formData).map(key => {
				if (!['workspace_id', 'file'].includes(key)) {
					let field = formFields.find(form => form.name === key);
					if (field) {
						formData[key].id = field.id;
						formData[key].field_type = field.field_type;
					}
				}
			})

			page.loaded = true;
		}
		this.setState({ ...this.state, page, formData, formFields });
	}

	getFields = async () => {
		let request = await axios.get(`/api/tickets/get-fields?workspace=7`);
		return request.data;
	}

	inputChangeHandler = e => {
		let { formData, formErrors } = this.state
		formData[e.target.name].value = e.target.value;

		if (formErrors.includes(e.target.name)) {
			let idx = formErrors.indexOf(e.target.name);
			formErrors.splice(idx, 1);
		}

		this.setState({ ...this.state, formData, formErrors });
	}

	attachFileHandler = (e, fileIdx) => {
		let { formData, formErrors, formErrorModal } = { ...this.state };
		let files = e.target.files;
		let error = [];
		let fileTypeError = false;
		let  fileSize = 0;
		for (let i = 0; i < files.length; i++) {
			fileSize = fileSize + files[i].size; 
			if(!allowedMimeTypes.includes(files[i].type)) {
				fileTypeError= true;
			}

		}

		if(fileTypeError==true) {
			formErrorModal.show = true;
			formErrorModal.message = [];
			formErrorModal.message.push(<h3>{MSG.fileType.title}</h3>);
			formErrorModal.message.push(<p>{MSG.fileType.message}</p>);

		}else if (fileSize > allowedSize) {
			formErrorModal.show = true;
			formErrorModal.message = [];
			formErrorModal.message.push(<h3>{MSG.fileSize.title}</h3>);
			formErrorModal.message.push(<p>{MSG.fileSize.message}</p>);

		} else {
			if (formErrors.includes(`${fileIdx}_file`)) {
				let fIdx = formErrors.indexOf(`${fileIdx}_file`);
				formErrors.splice(fIdx, 1);
			}
			formData.file = files
		}

		this.setState({ ...this.state, formData, formErrors });
	}

	removeAttachment = (e, idx) => {
		e.preventDefault();
		let formData = this.state.formData;
		formData.file = Array.from(formData.file);
		formData.file.splice(idx, 1);
		this.setState({ formData });
	}

	validateEmail = (email) => {
		return String(email)
			.toLowerCase()
			.match(
				/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
			);
	};

	submitForm = e => {
		e.preventDefault();
		let { formData, formErrors, formStatus, isAttachmentRequired, requiredFieldModal } = this.state;

		formErrors = [];

		if (isAttachmentRequired) {
			if (!formData.file || formData.file.length <= 0) {
				if (!formErrors.includes('file')) formErrors.push("file");
			}
		}

		Object.keys(formData).map(key => {

			let findField = this.state.formFields.find(field => field.name === key);
			if (findField) {
				//exceptions
				if (!['description'].includes(findField.name)) {
					if (findField.required_for_customers && formData[key].value === '') formErrors.push(key);
				}
			}

			if (key === 'requester') {
				let isEmail = this.validateEmail(formData[key].value);
				if (!isEmail) {
					if (!formErrors.includes(key)) formErrors.push(key)
				}
			}
		})

		formStatus.submitted = formErrors.length > 0 ? false : true;
		requiredFieldModal.show = formErrors.length > 0 ? true : false;
		this.setState({ ...this.state, formErrors, formStatus, requiredFieldModal }, () => {
			if (this.state.formErrors.length < 1) this.sendForm()
		});
	}

	sendForm = () => {
		let formData = this.state.formData;
		let FD = new FormData();

		if (formData.file !== null) {
			for (const key of Object.keys(formData.file)) {
				FD.append('file', formData.file[key], formData.file[key].name);
			}
		}

		Object.keys(formData).map(key => {
			if (!['file', 'ticket_info'].includes(key)) {
				FD.append(key, JSON.stringify(formData[key]));
			}
		})


		return axios.post('/api/tickets', FD)
			.then(response => {
				let { formStatus, submitModal } = this.state
				formStatus.submitted = false;
				submitModal.show = true;
				return this.setState({ ...this.state, formStatus, submitModal });
			}).catch(err => {
				let { errors } = err.response.data;
				let { formStatus, formErrorModal } = { ...this.state }

				formErrorModal.show = true;
				formStatus.submitted = false;

				formErrorModal.message = [];
				formErrorModal.message.push(<h3>Form did not submit</h3>)

				if (errors.hasOwnProperty('errors') && errors.errors.length > 0) {
					errors.errors.map((error, idx) => {
						formErrorModal.message.push(<p key={idx}>{error.message}</p>);
					})
				}
				return this.setState({ ...this.state, formStatus });
			})

	}

	closeRequiredFieldModal = e => {
		e.preventDefault();
		let { requiredFieldModal } = this.state;
		requiredFieldModal.show = false;
		this.setState({ ...this.state, requiredFieldModal });
	}

	closeSubmitModal = e => {
		e.preventDefault();
		window.location.reload();
	}

	closeErrorModal = e => {
		e.preventDefault();
		let { formErrorModal } = this.state;
		formErrorModal.show = false;
		formErrorModal.message = "";
		this.setState({ ...this.state, formErrorModal });
	}

	displayField = (field) => {
		let { formErrors, formStatus, formData } = this.state;
		let findField = this.state.formFields.find(formData => formData.name === field);
		if (field === "subject") {
			findField.label_for_customers = "Reason or purpose of employment check";
		}

		if (findField) return <InputField field={findField} show={formData[findField.name].show} value={formData[findField.name].value} formErrors={formErrors} formStatus={formStatus} inputChangeHandler={e => this.inputChangeHandler(e)} />
		return null;
	}

	displayTicketInfo = (ticket_info) => {
		let { formErrors, formStatus, formData, formFields } = this.state;

		let elements = [];
		Object.keys(ticket_info).map((key, idx) => {
			let findField = this.state.formFields.find(formData => formData.name === key);

			if (findField) {
				elements.push(
					<>
						<div key={`${idx}_${key}`} className="col-12">
							<InputField className={null} field={findField} value={formData.ticket_info[key].value} formErrors={formErrors} formStatus={formStatus} inputChangeHandler={e => this.ticketInfoChangeHandler(e)} />
						</div>
					</>
				)
			}
		})

		return elements;
	}

	displayAttachedFiles = () => {
		let formData = this.state.formData;

		let data = [];


		if (formData.file.length > 0) {

			for (let i = 0; i < formData.file.length; i++) {
				data.push(
					<div className="chip" key={i}>
						<span>{formData.file[i].name}</span>
						<a
							href="#"
							className="close"
							onClick={e => this.removeAttachment(e, i)}
						>
							<i className="bi bi-x"></i>
						</a>
					</div>
				)
			}
		}

		return data;
	}

	render() {
		let { formData, formStatus, submitModal, formErrorModal, page, attachmentMessages, formErrors, requiredFieldModal } = this.state;

		return page.loaded ? (
			<>
				<h4 style={{ color: '#ffffff' }}>
					In order for us to address your concerns accurately and efficiently, we kindly request that you provide us with the following information. This will enable us to expedite our response to your concern.
				</h4>

				<div className='row'>
					<div className="col-lg-6 col-md-6 col-xs-12 mt-3">
						{this.displayField("full_name_of_the_requestor_first_name_last_name")}
					</div>

					<div className="col-lg-6 col-md-6 col-xs-12 mt-3">
						{this.displayField("requester")}
					</div>

					<div className="col-lg-6 col-md-6 col-xs-12 mt-3">
						{this.displayField("position_of_the_requestor")}
					</div>

					<div className="col-lg-6 col-md-6 col-xs-12 mt-3">
						{this.displayField("establishment_or_company_represented_by_requestor")}
					</div>

				</div>

				<div className='row' style={{ marginBottom: '50px' }}>
					<h4 style={{ marginTop: '50px', color: '#ffffff' }}>How can we help you today?</h4>

					<div className="col-lg-12 col-md-12 col-xs-12 mt-3">
						{this.displayField("type_of_inquiry_nonemapta_member")}
					</div>

					<div className="col-lg-12 col-md-126 col-xs-12 mt-3">
						{this.displayField("full_name_of_the_emapta_employee_that_is_being_verifiedchecked_first_name_middle_name_last_name")}
					</div>

					<div className="col-lg-12 col-md-126 col-xs-12 mt-3">
						{this.displayField("type_the_employee_id_number_of_the_emapta_staff_if_available")}
					</div>

					<div className="col-lg-12 col-md-126 col-xs-12 mt-3">
						{this.displayField("subject")}
					</div>

					<div className="col-lg-12 col-md-12 col-xs-12 mt-3">
						{this.displayField("description")}
					</div>

					<div className="col-12">
						{attachmentMessages.length > 0 ?
							<>
								<label>Files to attach *:  </label>
								<p style={{ fontWeight: 'normal', marginTop: 10, marginBottom: 10, }}>
									<ul>
										{attachmentMessages.map((message, idx) => <li key={idx}>{message}</li>)}
									</ul>
								</p>
							</>
							:
							<label>Files  *</label>
						}
						<div className="file-upload ">
							<div className="file-upload-btn" >
								<label style={formErrors.includes(`file`) ? { borderColor: 'red' } : {}} >

									<i className="bi bi-paperclip"></i>
									Attach File
								</label>
								<input
									type="file"
									id="file"
									name='file'
									accept=".jpeg,.jpg,.gif,.png,.pdf,.doc,.docx,.xls,.xlsx,.csv"
									multiple
									className="form-control"
									onChange={e => this.attachFileHandler(e)}
									disabled={formStatus.submitted}
								/>
							</div>
							<span className="text-muted"><i>{MSG.general}</i></span>

							<div className="attach-chips">
								{formData.file !== null && this.displayAttachedFiles()}
							</div>
						</div>
					</div>
				</div>

				<div className="row action-btn">
					<div className="col-12">
						<button
							style={{ float: 'right' }}
							type="button"
							data-bs-toggle="modal"
							data-bs-target="#successModal"

							onClick={e => this.submitForm(e)}
							disabled={formStatus.submitted}
						>

							{formStatus.submitted ?
								<><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> &nbsp; Submitting... </>
								:
								<>
									<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M4.91396 10L2.88989 16.0933L16.4333 10L2.88989 3.90673L4.91396 10ZM2.61324 10L0.0483426 17.7214C-0.228127 18.5537 0.733799 19.2809 1.59727 18.8925L19.3907 10.8871C20.2031 10.5216 20.2031 9.47843 19.3907 9.11295L1.59726 1.10753C0.733796 0.719051 -0.228127 1.44632 0.048342 2.2786L2.61324 10Z" fill="#fff"></path><path fillRule="evenodd" clipRule="evenodd" d="M3 10C3 9.44772 3.44772 9 4 9L17 9C17.5523 9 18 9.44772 18 10C18 10.5523 17.5523 11 17 11L4 11C3.44772 11 3 10.5523 3 10Z" fill="#fff"></path></svg> SUBMIT </>
							}
						</button>
					</div>
				</div>


				<Modal show={submitModal.show} size='md' id="successModal" >
					{/* <Modal show={} size='md' id="successModal" > */}
					<div className="modal-content" >
						<div className="modal-body text-center">
							<>
								<h3>Thank you for submitting your query in C.H.E.E.R.</h3>
								<p>Please expect a member of our HR team to contact you shortly.</p>
							</>

						</div>
						<div className="modal-footer">
							<button
								onClick={e => this.closeSubmitModal(e)}
								type="button"
								className="btn btn-primary"
								data-bs-dismiss="modal"
								aria-label="Close"
							>
								<i className="bi bi-x-lg"></i>
							</button>
						</div>
					</div>
				</Modal>

				<Modal show={requiredFieldModal.show} size='md' id="successModal" >
					{/* <Modal show={} size='md' id="successModal" > */}
					<div className="modal-content" >
						<div className="modal-body text-center">
							<>
								<p style={{ fontWeight: 'normal', color: 'black', fontSize: 21 }}>
									All fields marked by red are mandatory.
								</p>
							</>

						</div>
						<div className="modal-footer">
							<button
								onClick={e => this.closeRequiredFieldModal(e)}
								type="button"
								className="btn btn-primary"
								data-bs-dismiss="modal"
								aria-label="Close"
							>
								<i className="bi bi-x-lg"></i>
							</button>
						</div>
					</div>
				</Modal>

				{formErrorModal.show &&
					<Modal show={formErrorModal.show} size='md' id="successModal" >
						{/* <Modal show={} size='md' id="successModal" > */}
						<div className="modal-content" >
							<div className="modal-body">
								{formErrorModal.message}
							</div>
							<div className="modal-footer">
								<button
									onClick={e => this.closeErrorModal(e)}
									type="button"
									className="btn btn-primary"
									data-bs-dismiss="modal"
									aria-label="Close"
								>
									<i className="bi bi-x-lg"></i>
								</button>
							</div>
						</div>
					</Modal>
				}

			</>
		)
			: <Spinner />
	}
}

export default InactiveEmapta;

